export enum InvoicePeriodEnum {
    ONE_TIME = 'one_time',
    BI_ANNUAL = 'bi_annual',
    QUARTERLY = 'quarterly',
    MONTHLY = 'monthly',
    PER_ACTIVATIONS = 'per_activations',
}
